import { ContentSlider, ImageCarousel } from '../../shared/carousel';
import './style.scss';

const CarouselItem = ({ item }) => (
    <div className="col-12 col-lg-6">
        <div className="p-2">
            <div className="row">
                <div className="col pb-3">
                    <ImageCarousel {...item} />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <h5>{item.title}</h5>
                    <p>{item.text}</p>
                </div>
            </div>
        </div>
    </div>
);

const SectionHeader = () => (
    <div className="row">
        <div className="col">
            <img src="/img/fm-pro-logo.png" alt="FMPro™" className="img-fluid fm-pro-logo" />
            <span className="section-title d-none d-lg-inline-block">
                Technology for <span className="section-title-highlight"> Mission Based Services</span>
            </span>
        </div>
    </div>
);

const SectionContent = ({ description, cards }) => (
    <div className="row mt-3">
        <div className="col-12 col-lg-4 mb-3 mb-lg-0">
            <p className="section-text p-2">
                {description}
            </p>
        </div>
        <div className="col-12 col-lg-8">
            <ContentSlider items={cards} renderItemTemplate={(item) => <CarouselItem item={item} />} />
        </div>
    </div>
);

const FmProSection = (settings) => {
    return (
        <div className="container my-5">
            <SectionHeader />
            <SectionContent description={settings.description} cards={settings.cards} />
        </div>
    );
};

export default FmProSection;
